// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1B4bS","imageUploader":"EGiftCard_imageUploader__1i3Pz"};